import apiFetch from '../apiFetch'

export default function (token, documentVisualization) {
  return apiFetch({ endPoint: 'DocumentVisualization', method: 'POST', body: documentVisualization, token: token })
}
